import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { ErrorComponent } from './views/error/error.component';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { ErrorInterceptorProvider } from './core/services/Helper/error.interceptor';
import { NoCacheInterceptorProvider } from './core/services/Helper/nocache.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
  ],
  imports: [
    NgxPaginationModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    HttpClientJsonpModule,
    FormsModule,
    ReactiveFormsModule,
    ShareIconsModule,
    ShareButtonsModule
  ],
  providers: [ErrorInterceptorProvider, NoCacheInterceptorProvider],
  bootstrap: [AppComponent]
})
export class AppModule { }
